import React from 'react';
import { unwrapModel } from '../../../services/api/unwrapModel';
import { useGetAllNotesByFindingSuspense } from '../../../services/api/generated/client';
import { FIVE_MIN_STALE_TIME } from '../../../services/api/query/queryClient';
import NotesWrapper from './NotesWrapper';
const FindingNotesWrapper = (props) => {
    const { data: notesResponse, refetch } = useGetAllNotesByFindingSuspense(props.model.id, { query: { staleTime: FIVE_MIN_STALE_TIME } });
    const notes = unwrapModel(notesResponse);
    if (!notes) {
        return null;
    }
    return (React.createElement(NotesWrapper, { ...props, canEdit: props.canEdit, type: "defect", onNotesMutated: () => {
            props.onMutated?.();
            refetch();
        }, notes: notes }));
};
export default FindingNotesWrapper;
